import request from '../utils/http'
// 应用列表
export function index (query) {
  return request({
    url: '/modular/list',
    method: 'GET',
    params: query
  })
}
// 应用开关
export function show (query) {
  return request({
    url: '/modular/show',
    method: 'POST',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/modular.js